<script>
    import BaseListener from '@/assets/plugins/mps-common/event/base-listener'

    export default {
        name: "OnMainSearchTriggered",
        extends: BaseListener,
        mounted() {
            this.registerListener(this.mpsEvents.ON_MAIN_SEARCH_TRIGGERED, this.onMainSearchTriggered);
        },
        unmounted() {
            this.unregisterListener(this.mpsEvents.ON_MAIN_SEARCH_TRIGGERED, this.onMainSearchTriggered);
        },
        methods: {
            onMainSearchTriggered() {
                alert('onMainSearchTriggered is needed to be implemented!');
            }
        },
    }
</script>
